(() => {
  var e = {
    296: (e, t, r) => {
      var n = /^\s+|\s+$/g,
          o = /^[-+]0x[0-9a-f]+$/i,
          i = /^0b[01]+$/i,
          c = /^0o[0-7]+$/i,
          s = parseInt,
          u = "object" == typeof r.g && r.g && r.g.Object === Object && r.g,
          l = "object" == typeof self && self && self.Object === Object && self,
          a = u || l || Function("return this")(),
          f = Object.prototype.toString,
          p = Math.max,
          y = Math.min,
          d = function () {
        return a.Date.now();
      };

      function b(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
      }

      function h(e) {
        if ("number" == typeof e) return e;
        if (function (e) {
          return "symbol" == typeof e || function (e) {
            return !!e && "object" == typeof e;
          }(e) && "[object Symbol]" == f.call(e);
        }(e)) return NaN;

        if (b(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
          e = b(t) ? t + "" : t;
        }

        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(n, "");
        var r = i.test(e);
        return r || c.test(e) ? s(e.slice(2), r ? 2 : 8) : o.test(e) ? NaN : +e;
      }

      e.exports = function (e, t, r) {
        var n,
            o,
            i,
            c,
            s,
            u,
            l = 0,
            a = !1,
            f = !1,
            v = !0;
        if ("function" != typeof e) throw new TypeError("Expected a function");

        function m(t) {
          var r = n,
              i = o;
          return n = o = void 0, l = t, c = e.apply(i, r);
        }

        function O(e) {
          return l = e, s = setTimeout(g, t), a ? m(e) : c;
        }

        function w(e) {
          var r = e - u;
          return void 0 === u || r >= t || r < 0 || f && e - l >= i;
        }

        function g() {
          var e = d();
          if (w(e)) return P(e);
          s = setTimeout(g, function (e) {
            var r = t - (e - u);
            return f ? y(r, i - (e - l)) : r;
          }(e));
        }

        function P(e) {
          return s = void 0, v && n ? m(e) : (n = o = void 0, c);
        }

        function j() {
          var e = d(),
              r = w(e);

          if (n = arguments, o = this, u = e, r) {
            if (void 0 === s) return O(u);
            if (f) return s = setTimeout(g, t), m(u);
          }

          return void 0 === s && (s = setTimeout(g, t)), c;
        }

        return t = h(t) || 0, b(r) && (a = !!r.leading, i = (f = "maxWait" in r) ? p(h(r.maxWait) || 0, t) : i, v = "trailing" in r ? !!r.trailing : v), j.cancel = function () {
          void 0 !== s && clearTimeout(s), l = 0, n = u = o = s = void 0;
        }, j.flush = function () {
          return void 0 === s ? c : P(d());
        }, j;
      };
    },
    96: (e, t, r) => {
      var n = "Expected a function",
          o = /^\s+|\s+$/g,
          i = /^[-+]0x[0-9a-f]+$/i,
          c = /^0b[01]+$/i,
          s = /^0o[0-7]+$/i,
          u = parseInt,
          l = "object" == typeof r.g && r.g && r.g.Object === Object && r.g,
          a = "object" == typeof self && self && self.Object === Object && self,
          f = l || a || Function("return this")(),
          p = Object.prototype.toString,
          y = Math.max,
          d = Math.min,
          b = function () {
        return f.Date.now();
      };

      function h(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
      }

      function v(e) {
        if ("number" == typeof e) return e;
        if (function (e) {
          return "symbol" == typeof e || function (e) {
            return !!e && "object" == typeof e;
          }(e) && "[object Symbol]" == p.call(e);
        }(e)) return NaN;

        if (h(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
          e = h(t) ? t + "" : t;
        }

        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(o, "");
        var r = c.test(e);
        return r || s.test(e) ? u(e.slice(2), r ? 2 : 8) : i.test(e) ? NaN : +e;
      }

      e.exports = function (e, t, r) {
        var o = !0,
            i = !0;
        if ("function" != typeof e) throw new TypeError(n);
        return h(r) && (o = "leading" in r ? !!r.leading : o, i = "trailing" in r ? !!r.trailing : i), function (e, t, r) {
          var o,
              i,
              c,
              s,
              u,
              l,
              a = 0,
              f = !1,
              p = !1,
              m = !0;
          if ("function" != typeof e) throw new TypeError(n);

          function O(t) {
            var r = o,
                n = i;
            return o = i = void 0, a = t, s = e.apply(n, r);
          }

          function w(e) {
            return a = e, u = setTimeout(P, t), f ? O(e) : s;
          }

          function g(e) {
            var r = e - l;
            return void 0 === l || r >= t || r < 0 || p && e - a >= c;
          }

          function P() {
            var e = b();
            if (g(e)) return j(e);
            u = setTimeout(P, function (e) {
              var r = t - (e - l);
              return p ? d(r, c - (e - a)) : r;
            }(e));
          }

          function j(e) {
            return u = void 0, m && o ? O(e) : (o = i = void 0, s);
          }

          function T() {
            var e = b(),
                r = g(e);

            if (o = arguments, i = this, l = e, r) {
              if (void 0 === u) return w(l);
              if (p) return u = setTimeout(P, t), O(l);
            }

            return void 0 === u && (u = setTimeout(P, t)), s;
          }

          return t = v(t) || 0, h(r) && (f = !!r.leading, c = (p = "maxWait" in r) ? y(v(r.maxWait) || 0, t) : c, m = "trailing" in r ? !!r.trailing : m), T.cancel = function () {
            void 0 !== u && clearTimeout(u), a = 0, o = l = i = u = void 0;
          }, T.flush = function () {
            return void 0 === u ? s : j(b());
          }, T;
        }(e, t, {
          leading: o,
          maxWait: t,
          trailing: i
        });
      };
    },
    703: (e, t, r) => {
      "use strict";

      var n = r(414);

      function o() {}

      function i() {}

      i.resetWarningCache = o, e.exports = function () {
        function e(e, t, r, o, i, c) {
          if (c !== n) {
            var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw s.name = "Invariant Violation", s;
          }
        }

        function t() {
          return e;
        }

        e.isRequired = e;
        var r = {
          array: e,
          bool: e,
          func: e,
          number: e,
          object: e,
          string: e,
          symbol: e,
          any: e,
          arrayOf: t,
          element: e,
          elementType: e,
          instanceOf: t,
          node: e,
          objectOf: t,
          oneOf: t,
          oneOfType: t,
          shape: t,
          exact: t,
          checkPropTypes: i,
          resetWarningCache: o
        };
        return r.PropTypes = r, r;
      };
    },
    697: (e, t, r) => {
      e.exports = r(703)();
    },
    414: e => {
      "use strict";

      e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }
  },
      t = {};

  function r(n) {
    var o = t[n];
    if (void 0 !== o) return o.exports;
    var i = t[n] = {
      exports: {}
    };
    return e[n](i, i.exports, r), i.exports;
  }

  r.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return r.d(t, {
      a: t
    }), t;
  }, r.d = (e, t) => {
    for (var n in t) r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
      enumerable: !0,
      get: t[n]
    });
  }, r.g = function () {
    if ("object" == typeof globalThis) return globalThis;

    try {
      return this || new Function("return this")();
    } catch (e) {
      if ("object" == typeof window) return window;
    }
  }(), r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), r.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var n = {};
  (() => {
    "use strict";

    r.r(n), r.d(n, {
      LazyLoadComponent: () => J,
      LazyLoadImage: () => ue,
      trackWindowScroll: () => C
    });

    const e = require("react");

    var t = r.n(e),
        o = r(697);

    const i = require("react-dom");

    var c = r.n(i);

    function s() {
      return "undefined" != typeof window && "IntersectionObserver" in window && "isIntersecting" in window.IntersectionObserverEntry.prototype;
    }

    function u(e) {
      return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function l(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function a(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function f(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function p(e, t) {
      return (p = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function y(e, t) {
      if (t && ("object" === u(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function d(e) {
      return (d = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var b = function (e) {
      e.forEach(function (e) {
        e.isIntersecting && e.target.onVisible();
      });
    },
        h = {},
        v = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && p(e, t);
      }(v, e);
      var r,
          n,
          o,
          i,
          u = (o = v, i = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }(), function () {
        var e,
            t = d(o);

        if (i) {
          var r = d(this).constructor;
          e = Reflect.construct(t, arguments, r);
        } else e = t.apply(this, arguments);

        return y(this, e);
      });

      function v(e) {
        var t;

        if (function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, v), (t = u.call(this, e)).supportsObserver = !e.scrollPosition && e.useIntersectionObserver && s(), t.supportsObserver) {
          var r = e.threshold;

          t.observer = function (e) {
            return h[e] = h[e] || new IntersectionObserver(b, {
              rootMargin: e + "px"
            }), h[e];
          }(r);
        }

        return t;
      }

      return r = v, (n = [{
        key: "componentDidMount",
        value: function () {
          this.placeholder && this.observer && (this.placeholder.onVisible = this.props.onVisible, this.observer.observe(this.placeholder)), this.supportsObserver || this.updateVisibility();
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.observer && this.observer.unobserve(this.placeholder);
        }
      }, {
        key: "componentDidUpdate",
        value: function () {
          this.supportsObserver || this.updateVisibility();
        }
      }, {
        key: "getPlaceholderBoundingBox",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props.scrollPosition,
              t = this.placeholder.getBoundingClientRect(),
              r = c().findDOMNode(this.placeholder).style,
              n = {
            left: parseInt(r.getPropertyValue("margin-left"), 10) || 0,
            top: parseInt(r.getPropertyValue("margin-top"), 10) || 0
          };
          return {
            bottom: e.y + t.bottom + n.top,
            left: e.x + t.left + n.left,
            right: e.x + t.right + n.left,
            top: e.y + t.top + n.top
          };
        }
      }, {
        key: "isPlaceholderInViewport",
        value: function () {
          if ("undefined" == typeof window || !this.placeholder) return !1;
          var e = this.props,
              t = e.scrollPosition,
              r = e.threshold,
              n = this.getPlaceholderBoundingBox(t),
              o = t.y + window.innerHeight,
              i = t.x,
              c = t.x + window.innerWidth,
              s = t.y;
          return Boolean(s - r <= n.bottom && o + r >= n.top && i - r <= n.right && c + r >= n.left);
        }
      }, {
        key: "updateVisibility",
        value: function () {
          this.isPlaceholderInViewport() && this.props.onVisible();
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              r = this.props,
              n = r.className,
              o = r.height,
              i = r.placeholder,
              c = r.style,
              s = r.width;
          if (i && "function" != typeof i.type) return t().cloneElement(i, {
            ref: function (t) {
              return e.placeholder = t;
            }
          });

          var u = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? l(Object(r), !0).forEach(function (t) {
                a(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }

            return e;
          }({
            display: "inline-block"
          }, c);

          return void 0 !== s && (u.width = s), void 0 !== o && (u.height = o), t().createElement("span", {
            className: n,
            ref: function (t) {
              return e.placeholder = t;
            },
            style: u
          }, i);
        }
      }]) && f(r.prototype, n), v;
    }(t().Component);

    v.propTypes = {
      onVisible: o.PropTypes.func.isRequired,
      className: o.PropTypes.string,
      height: o.PropTypes.oneOfType([o.PropTypes.number, o.PropTypes.string]),
      placeholder: o.PropTypes.element,
      threshold: o.PropTypes.number,
      useIntersectionObserver: o.PropTypes.bool,
      scrollPosition: o.PropTypes.shape({
        x: o.PropTypes.number.isRequired,
        y: o.PropTypes.number.isRequired
      }),
      width: o.PropTypes.oneOfType([o.PropTypes.number, o.PropTypes.string])
    }, v.defaultProps = {
      className: "",
      placeholder: null,
      threshold: 100,
      useIntersectionObserver: !0
    };
    const m = v;

    var O = r(296),
        w = r.n(O),
        g = r(96),
        P = r.n(g),
        j = function (e) {
      var t = getComputedStyle(e, null);
      return t.getPropertyValue("overflow") + t.getPropertyValue("overflow-y") + t.getPropertyValue("overflow-x");
    };

    const T = function (e) {
      if (!(e instanceof HTMLElement)) return window;

      for (var t = e; t && t instanceof HTMLElement;) {
        if (/(scroll|auto)/.test(j(t))) return t;
        t = t.parentNode;
      }

      return window;
    };

    function S(e) {
      return (S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    var E = ["delayMethod", "delayTime"];

    function _() {
      return (_ = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }

        return e;
      }).apply(this, arguments);
    }

    function I(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function L(e, t) {
      return (L = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function x(e, t) {
      if (t && ("object" === S(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return R(e);
    }

    function R(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function k(e) {
      return (k = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var D = function () {
      return "undefined" == typeof window ? 0 : window.scrollX || window.pageXOffset;
    },
        N = function () {
      return "undefined" == typeof window ? 0 : window.scrollY || window.pageYOffset;
    };

    const C = function (e) {
      var r = function (r) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && L(e, t);
        }(a, r);
        var n,
            o,
            i,
            u,
            l = (i = a, u = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
              t = k(i);

          if (u) {
            var r = k(this).constructor;
            e = Reflect.construct(t, arguments, r);
          } else e = t.apply(this, arguments);

          return x(this, e);
        });

        function a(e) {
          var r;
          if (function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), (r = l.call(this, e)).useIntersectionObserver = e.useIntersectionObserver && s(), r.useIntersectionObserver) return x(r);
          var n = r.onChangeScroll.bind(R(r));
          return "debounce" === e.delayMethod ? r.delayedScroll = w()(n, e.delayTime) : "throttle" === e.delayMethod && (r.delayedScroll = P()(n, e.delayTime)), r.state = {
            scrollPosition: {
              x: D(),
              y: N()
            }
          }, r.baseComponentRef = t().createRef(), r;
        }

        return n = a, (o = [{
          key: "componentDidMount",
          value: function () {
            this.addListeners();
          }
        }, {
          key: "componentWillUnmount",
          value: function () {
            this.removeListeners();
          }
        }, {
          key: "componentDidUpdate",
          value: function () {
            "undefined" == typeof window || this.useIntersectionObserver || T(c().findDOMNode(this.baseComponentRef.current)) !== this.scrollElement && (this.removeListeners(), this.addListeners());
          }
        }, {
          key: "addListeners",
          value: function () {
            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement = T(c().findDOMNode(this.baseComponentRef.current)), this.scrollElement.addEventListener("scroll", this.delayedScroll, {
              passive: !0
            }), window.addEventListener("resize", this.delayedScroll, {
              passive: !0
            }), this.scrollElement !== window && window.addEventListener("scroll", this.delayedScroll, {
              passive: !0
            }));
          }
        }, {
          key: "removeListeners",
          value: function () {
            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement.removeEventListener("scroll", this.delayedScroll), window.removeEventListener("resize", this.delayedScroll), this.scrollElement !== window && window.removeEventListener("scroll", this.delayedScroll));
          }
        }, {
          key: "onChangeScroll",
          value: function () {
            this.useIntersectionObserver || this.setState({
              scrollPosition: {
                x: D(),
                y: N()
              }
            });
          }
        }, {
          key: "render",
          value: function () {
            var r = this.props,
                n = (r.delayMethod, r.delayTime, function (e, t) {
              if (null == e) return {};

              var r,
                  n,
                  o = function (e, t) {
                if (null == e) return {};
                var r,
                    n,
                    o = {},
                    i = Object.keys(e);

                for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);

                return o;
              }(e, t);

              if (Object.getOwnPropertySymbols) {
                var i = Object.getOwnPropertySymbols(e);

                for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
              }

              return o;
            }(r, E)),
                o = this.useIntersectionObserver ? null : this.state.scrollPosition;
            return t().createElement(e, _({
              forwardRef: this.baseComponentRef,
              scrollPosition: o
            }, n));
          }
        }]) && I(n.prototype, o), a;
      }(t().Component);

      return r.propTypes = {
        delayMethod: o.PropTypes.oneOf(["debounce", "throttle"]),
        delayTime: o.PropTypes.number,
        useIntersectionObserver: o.PropTypes.bool
      }, r.defaultProps = {
        delayMethod: "throttle",
        delayTime: 300,
        useIntersectionObserver: !0
      }, r;
    };

    function M(e) {
      return (M = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function B(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function V(e, t) {
      return (V = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function W(e, t) {
      if (t && ("object" === M(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function z(e) {
      return (z = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var $ = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && V(e, t);
      }(s, e);
      var r,
          n,
          o,
          i,
          c = (o = s, i = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }(), function () {
        var e,
            t = z(o);

        if (i) {
          var r = z(this).constructor;
          e = Reflect.construct(t, arguments, r);
        } else e = t.apply(this, arguments);

        return W(this, e);
      });

      function s(e) {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, s), c.call(this, e);
      }

      return r = s, (n = [{
        key: "render",
        value: function () {
          return t().createElement(m, this.props);
        }
      }]) && B(r.prototype, n), s;
    }(t().Component);

    const U = C($);

    function q(e) {
      return (q = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function F(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function H(e, t) {
      return (H = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Y(e, t) {
      if (t && ("object" === q(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return X(e);
    }

    function X(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function A(e) {
      return (A = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var G = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && H(e, t);
      }(u, e);
      var r,
          n,
          o,
          i,
          c = (o = u, i = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }(), function () {
        var e,
            t = A(o);

        if (i) {
          var r = A(this).constructor;
          e = Reflect.construct(t, arguments, r);
        } else e = t.apply(this, arguments);

        return Y(this, e);
      });

      function u(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, u), t = c.call(this, e);
        var r = e.afterLoad,
            n = e.beforeLoad,
            o = e.scrollPosition,
            i = e.visibleByDefault;
        return t.state = {
          visible: i
        }, i && (n(), r()), t.onVisible = t.onVisible.bind(X(t)), t.isScrollTracked = Boolean(o && Number.isFinite(o.x) && o.x >= 0 && Number.isFinite(o.y) && o.y >= 0), t;
      }

      return r = u, (n = [{
        key: "componentDidUpdate",
        value: function (e, t) {
          t.visible !== this.state.visible && this.props.afterLoad();
        }
      }, {
        key: "onVisible",
        value: function () {
          this.props.beforeLoad(), this.setState({
            visible: !0
          });
        }
      }, {
        key: "render",
        value: function () {
          if (this.state.visible) return this.props.children;
          var e = this.props,
              r = e.className,
              n = e.delayMethod,
              o = e.delayTime,
              i = e.height,
              c = e.placeholder,
              u = e.scrollPosition,
              l = e.style,
              a = e.threshold,
              f = e.useIntersectionObserver,
              p = e.width;
          return this.isScrollTracked || f && s() ? t().createElement(m, {
            className: r,
            height: i,
            onVisible: this.onVisible,
            placeholder: c,
            scrollPosition: u,
            style: l,
            threshold: a,
            useIntersectionObserver: f,
            width: p
          }) : t().createElement(U, {
            className: r,
            delayMethod: n,
            delayTime: o,
            height: i,
            onVisible: this.onVisible,
            placeholder: c,
            style: l,
            threshold: a,
            width: p
          });
        }
      }]) && F(r.prototype, n), u;
    }(t().Component);

    G.propTypes = {
      afterLoad: o.PropTypes.func,
      beforeLoad: o.PropTypes.func,
      useIntersectionObserver: o.PropTypes.bool,
      visibleByDefault: o.PropTypes.bool
    }, G.defaultProps = {
      afterLoad: function () {
        return {};
      },
      beforeLoad: function () {
        return {};
      },
      useIntersectionObserver: !0,
      visibleByDefault: !1
    };
    const J = G;

    function K(e) {
      return (K = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    var Q = ["afterLoad", "beforeLoad", "delayMethod", "delayTime", "effect", "placeholder", "placeholderSrc", "scrollPosition", "threshold", "useIntersectionObserver", "visibleByDefault", "wrapperClassName", "wrapperProps"];

    function Z(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function ee(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Z(Object(r), !0).forEach(function (t) {
          te(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Z(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function te(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function re() {
      return (re = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }

        return e;
      }).apply(this, arguments);
    }

    function ne(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function oe(e, t) {
      return (oe = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ie(e, t) {
      if (t && ("object" === K(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function ce(e) {
      return (ce = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var se = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && oe(e, t);
      }(s, e);
      var r,
          n,
          o,
          i,
          c = (o = s, i = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }(), function () {
        var e,
            t = ce(o);

        if (i) {
          var r = ce(this).constructor;
          e = Reflect.construct(t, arguments, r);
        } else e = t.apply(this, arguments);

        return ie(this, e);
      });

      function s(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, s), (t = c.call(this, e)).state = {
          loaded: !1
        }, t;
      }

      return r = s, (n = [{
        key: "onImageLoad",
        value: function () {
          var e = this;
          return this.state.loaded ? null : function () {
            e.props.afterLoad(), e.setState({
              loaded: !0
            });
          };
        }
      }, {
        key: "getImg",
        value: function () {
          var e = this.props,
              r = (e.afterLoad, e.beforeLoad, e.delayMethod, e.delayTime, e.effect, e.placeholder, e.placeholderSrc, e.scrollPosition, e.threshold, e.useIntersectionObserver, e.visibleByDefault, e.wrapperClassName, e.wrapperProps, function (e, t) {
            if (null == e) return {};

            var r,
                n,
                o = function (e, t) {
              if (null == e) return {};
              var r,
                  n,
                  o = {},
                  i = Object.keys(e);

              for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);

              return o;
            }(e, t);

            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);

              for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
            }

            return o;
          }(e, Q));
          return t().createElement("img", re({
            onLoad: this.onImageLoad()
          }, r));
        }
      }, {
        key: "getLazyLoadImage",
        value: function () {
          var e = this.props,
              r = e.beforeLoad,
              n = e.className,
              o = e.delayMethod,
              i = e.delayTime,
              c = e.height,
              s = e.placeholder,
              u = e.scrollPosition,
              l = e.style,
              a = e.threshold,
              f = e.useIntersectionObserver,
              p = e.visibleByDefault,
              y = e.width;
          return t().createElement(J, {
            beforeLoad: r,
            className: n,
            delayMethod: o,
            delayTime: i,
            height: c,
            placeholder: s,
            scrollPosition: u,
            style: l,
            threshold: a,
            useIntersectionObserver: f,
            visibleByDefault: p,
            width: y
          }, this.getImg());
        }
      }, {
        key: "getWrappedLazyLoadImage",
        value: function (e) {
          var r = this.props,
              n = r.effect,
              o = r.height,
              i = r.placeholderSrc,
              c = r.width,
              s = r.wrapperClassName,
              u = r.wrapperProps,
              l = this.state.loaded,
              a = l ? " lazy-load-image-loaded" : "",
              f = l || !i ? {} : {
            backgroundImage: "url(".concat(i, ")"),
            backgroundSize: "100% 100%"
          };
          return t().createElement("span", re({
            className: s + " lazy-load-image-background " + n + a,
            style: ee(ee({}, f), {}, {
              color: "transparent",
              display: "inline-block",
              height: o,
              width: c
            })
          }, u), e);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.effect,
              r = e.placeholderSrc,
              n = e.visibleByDefault,
              o = e.wrapperClassName,
              i = e.wrapperProps,
              c = this.getLazyLoadImage();
          return (t || r) && !n || o || i ? this.getWrappedLazyLoadImage(c) : c;
        }
      }]) && ne(r.prototype, n), s;
    }(t().Component);

    se.propTypes = {
      afterLoad: o.PropTypes.func,
      beforeLoad: o.PropTypes.func,
      delayMethod: o.PropTypes.string,
      delayTime: o.PropTypes.number,
      effect: o.PropTypes.string,
      placeholderSrc: o.PropTypes.string,
      threshold: o.PropTypes.number,
      useIntersectionObserver: o.PropTypes.bool,
      visibleByDefault: o.PropTypes.bool,
      wrapperClassName: o.PropTypes.string,
      wrapperProps: o.PropTypes.object
    }, se.defaultProps = {
      afterLoad: function () {
        return {};
      },
      beforeLoad: function () {
        return {};
      },
      delayMethod: "throttle",
      delayTime: 300,
      effect: "",
      placeholderSrc: null,
      threshold: 100,
      useIntersectionObserver: !0,
      visibleByDefault: !1,
      wrapperClassName: ""
    };
    const ue = se;
  })(), module.exports = n;
})();